export default __webpack_public_path__ + "static/media/car-profile.f1fd6dbe.svg";